import { render, staticRenderFns } from "./PromotionShowcaseList.vue?vue&type=template&id=04afeed9&scoped=true&"
import script from "./PromotionShowcaseList.vue?vue&type=script&lang=js&"
export * from "./PromotionShowcaseList.vue?vue&type=script&lang=js&"
import style0 from "./PromotionShowcaseList.vue?vue&type=style&index=0&id=04afeed9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04afeed9",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCarousel } from 'vuetify/lib/components/VCarousel';
import { VCarouselItem } from 'vuetify/lib/components/VCarousel';
import { VChip } from 'vuetify/lib/components/VChip';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VOverlay } from 'vuetify/lib/components/VOverlay';
installComponents(component, {VCarousel,VCarouselItem,VChip,VContainer,VImg,VOverlay})
